"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.buildSchema = exports.getEntityRelationships = exports.isString = exports.adjustLinkedXToLinkedEntityWithRes = void 0;
var uniq_1 = __importDefault(require("lodash/uniq"));
var range_1 = __importDefault(require("lodash/range"));
var normalizr_1 = require("normalizr");
var createUnionSchema_1 = __importStar(require("../createUnionSchema"));
var isCapital = function (c) { return c.toUpperCase() === c; };
// like adjustLinkedXToLinkedEntity, except returns the related entity in _2
var disallowJustEntity = function (x) { return (x && x !== 'Entity' ? x : null); };
var adjustLinkedXToLinkedEntityWithRes = function (fieldName) {
    if (!fieldName) {
        // just in case undefined is passed at runtime
        // (this happens due to the CloneElement stuff where source isn't given to inputs initially)
        return [fieldName, null];
    }
    if (fieldName.startsWith('linked') && fieldName.length > 6 && isCapital(fieldName[6])) {
        var _a = fieldName.split('.'), first = _a[0], rest = _a.slice(1);
        return [__spreadArray(['linkedEntity'], rest, true).join('.'), disallowJustEntity(first.slice('linked'.length))];
    }
    var linkedIndex = fieldName.indexOf('.linked');
    if (linkedIndex !== -1 &&
        fieldName[linkedIndex + '.linked'.length] &&
        isCapital(fieldName[linkedIndex + '.linked'.length])) {
        var before = fieldName.slice(0, linkedIndex);
        var middle = fieldName.slice(linkedIndex + '.linked'.length).split('.')[0];
        var after = fieldName
            .slice(linkedIndex + 1)
            .split('.')
            .flatMap(function (v, i) { return (i === 0 ? [] : [v]); })
            .join('.');
        return ["".concat(before, ".linkedEntity").concat(after.length > 0 ? ".".concat(after) : ''), disallowJustEntity(middle)];
    }
    return [fieldName, null];
};
exports.adjustLinkedXToLinkedEntityWithRes = adjustLinkedXToLinkedEntityWithRes;
function isString(data) {
    return typeof data === 'string';
}
exports.isString = isString;
var getEntityRelationships = function (viewConfig, baseEntity, baseFieldExpr, exceptionEntities) {
    if (exceptionEntities === void 0) { exceptionEntities = []; }
    var relationships = {};
    /*
        [entityName]: {
            [fieldName]: '[otherentityName]?relationshiptype'
        }
    }
    */
    var getEntityRelForExpr = function (entity, fieldExpr) {
        if (!viewConfig.entities[entity]) {
            throw Error("Entity \"".concat(entity, "\" does not exist"));
        }
        if (exceptionEntities.indexOf(entity) !== -1) {
            return;
        }
        var viewFieldRefPath = fieldExpr.split('.');
        var _a = (0, exports.adjustLinkedXToLinkedEntityWithRes)(viewFieldRefPath[0]), subField1 = _a[0], linkedEntity = _a[1];
        var entityField = viewConfig.entities[entity].fields[subField1];
        if (!entityField) {
            throw Error("field \"".concat(subField1, "\" in \"").concat(fieldExpr, "\" not found on entity \"").concat(entity, "\""));
        }
        if (viewFieldRefPath.length === 1) {
            var thisField = viewConfig.entities[entity].fields[fieldExpr];
            var relEntity = thisField.relatedEntity;
            if (isString(relEntity)) {
                if (!relationships[entity]) {
                    relationships[entity] = {};
                }
                relationships[entity][fieldExpr] = "".concat(relEntity, "?").concat(thisField.dataType);
            }
        }
        else {
            var nextField = viewConfig.entities[entity].fields[subField1];
            var nextEntity = nextField.relatedEntity;
            if (isString(nextEntity)) {
                if (!relationships[entity]) {
                    relationships[entity] = {};
                }
                relationships[entity][subField1] = "".concat(nextEntity, "?").concat(nextField.dataType);
                getEntityRelForExpr(
                // essentially nextEntity === WILDCARD_ENTITY ? linkedEntity : nextEntity
                linkedEntity || nextEntity, (0, range_1.default)(1, viewFieldRefPath.length)
                    .map(function (i) { return viewFieldRefPath[i]; })
                    .join('.'));
            }
            else {
                throw Error("relatedEntity not found on the path \"".concat(fieldExpr, "\":\n                \"").concat(subField1, "\": \"").concat(viewConfig.entities[entity].fields[subField1], "\"\n                has no relatedEntity field"));
            }
        }
    };
    getEntityRelForExpr(baseEntity, baseFieldExpr);
    return relationships;
};
exports.getEntityRelationships = getEntityRelationships;
var buildSchema = function (entityMappings, viewConfig, includeXtoMany) {
    var entitySchemas = {};
    var entitySet = [];
    Object.keys(entityMappings).forEach(function (n) {
        entitySet.push(n);
    });
    Object.values(entityMappings).forEach(function (fieldSet) {
        Object.values(fieldSet).forEach(function (exp) {
            var entity = exp.split('?')[0];
            entitySet.push(entity);
        });
    });
    entitySet = (0, uniq_1.default)(entitySet).filter(function (e) { return e !== createUnionSchema_1.WILDCARD_ENTITY; }); // dedupe
    entitySet.forEach(function (entityName) {
        entitySchemas[entityName] = new normalizr_1.schema.Entity(entityName);
    });
    // now we have our base entities
    // next, we describe relationships between them.
    var unionSchema = (0, createUnionSchema_1.default)(__spreadArray(__spreadArray([], Object.keys(viewConfig.entities)
        .filter(function (ename) { return !entitySchemas[ename]; })
        .map(function (ename) { return new normalizr_1.schema.Entity(ename); }), true), Object.values(entitySchemas), true));
    Object.entries(entityMappings).forEach(function (_a) {
        var entityName = _a[0], fields = _a[1];
        var definition = Object.entries(fields).reduce(function (prev, _a) {
            var fieldName = _a[0], relExpression = _a[1];
            var _b = relExpression.split('?'), relatedEntity = _b[0], type = _b[1];
            switch (type) {
                case 'REFONE':
                case 'REFONE_JOIN':
                case 'VALUESET': {
                    prev[fieldName] = relatedEntity === createUnionSchema_1.WILDCARD_ENTITY ? unionSchema : entitySchemas[relatedEntity];
                    break;
                }
                case 'REFMANYMANY':
                case 'REFMANY':
                case 'REFMANY_JOIN':
                case 'VALUESETMANY': {
                    if (!includeXtoMany) {
                        break;
                    }
                    prev[fieldName] =
                        relatedEntity === createUnionSchema_1.WILDCARD_ENTITY
                            ? new normalizr_1.schema.Array(unionSchema)
                            : new normalizr_1.schema.Array(entitySchemas[relatedEntity]);
                    break;
                }
                default:
                    throw Error('Unknown relationship type ' +
                        type +
                        ', expected REFONE | REFONE_JOIN | REFMANY | REFMANYMANY | REFMANY_JOIN');
            }
            return prev;
        }, {});
        entitySchemas[entityName].define(definition);
    });
    return entitySchemas;
};
exports.buildSchema = buildSchema;
//# sourceMappingURL=buildSchemaUtils.js.map